module.exports = __webpack_public_path__ + "static/img/G3.b29e50d1.png";